import VueRouter, {RawLocation, Route} from 'vue-router';
import routes from './routes';
import {Vue} from 'vue-property-decorator';
import {
	TrackingService,
	SessionStore,
	EventsService,
	ERouteName,
	DisplayStore
} from '@customer-portal/shared';
import {nextTick} from 'process';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation
 */

// export default route<Store<IRootState>>(({Vue}) => {
// 	Vue.use(VueRouter);
//
// 	const Router = new VueRouter({
// 		scrollBehavior: () => {
// 			return {x: 0, y: 0};
// 		},
// 		routes,
//
// 		// Leave these as is and change from quasar.conf.js instead!
// 		// quasar.conf.js -> build -> vueRouterMode
// 		// quasar.conf.js -> build -> publicPath
// 		mode: process.env.VUE_ROUTER_MODE,
// 		base: process.env.VUE_ROUTER_BASE
// 	});
//
// 	return Router;
// });


const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = async function(location: RawLocation) {
	let route: Route;
	try {
		route = await originalPush.call<VueRouter, [RawLocation], Promise<Route>>(this, location);
	} catch(err: any) {
		if(err.name !== 'NavigationDuplicated') {
			throw err;
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	return route!;
};

Vue.use(VueRouter);

const router = new VueRouter({
	scrollBehavior: () => {
		return {x: 0, y: 0};
	},
	routes,

	// Leave these as is and change from quasar.conf.js instead!
	// quasar.conf.js -> build -> vueRouterMode
	// quasar.conf.js -> build -> publicPath
	mode: process.env.VUE_ROUTER_MODE,
	base: process.env.VUE_ROUTER_BASE
});
let initialLoad = true;
router.beforeEach((to, from, next) => {
	TrackingService.trackPageView(to);

	if(!initialLoad) {
		if(to.meta && to.meta.requiresAuth && SessionStore.authConfig === null) { // Handle pages that require auth
			console.debug('Global route guard - Page requires auth');
			next({
				name: ERouteName.Login
			});
			return;
		} else if(to.path === '/' && from.path !== '/') {
			console.debug('Global route guard - Navigating to root from non-root path: redirecting to Home');
			next({
				name: ERouteName.Home,
			});
			return;
		} else if(DisplayStore.isDesktop) { // Handle special desktop cases
			if(to.path === '/home' || to.path === '/home/') {
				console.debug('Global route guard - Desktop Home re-route to order.');
				next({
					name: ERouteName.Order,
					params: {
						showLocation: 'yes',
					},
				});
				return;
			}
		} else if(!DisplayStore.isDesktop) { // Handle special mobile cases
			if(!(to.path === '/' || to.path === 'login' || to.path === '/login/') && SessionStore.authConfig === null) {
				console.debug('Global route guard - Mobile unauthenticated: redirect to login.');
				next({
					name: ERouteName.Login
				});
				return;
			}
		}
	}

	if(initialLoad) {
		initialLoad = false;
	}

	console.debug('Global route guard - Next');

	next();
});
if(EventsService.isEnabled()) {
	router.afterEach((to) => {
		nextTick(() => {
			EventsService.recordPageView(to.fullPath);
		});
	});
}


export default router;
